import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getisCompletedAssessment } from "../axios/axiosFunctions";
import { Box, Button, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const MyAssessmentCardProfile = ({ assessment }) => {
  const { userId } = useParams();
  const [completed, setCompleted] = useState(false);

  useEffect(() => {
    if (assessment.is360) return;
    const checkIfComplete = async () => {
      const isComplete = await getisCompletedAssessment(assessment._id, userId);
      if (isComplete.valid) {
        setCompleted(true);
      }
    };
    checkIfComplete();
  }, [assessment]);

  return (
    <div className="assessmentCard">
      <div style={{ display: "flex", alignItems: "center" }}>
        <div className="assessmentCardIcon">
          <img
            className="assesmentMainImage"
            alt="Assessment Logo"
            src={assessment.mainImage}
          />
        </div>
        <Typography
          component={"div"}
          variant="h5"
          fontWeight={600}
          align="center"
          color="secondary"
          sx={{
            marginLeft: "30px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            flex: 1,
            minWidth: 0,
            marginRight: "1rem",
          }}
          dangerouslySetInnerHTML={{ __html: `${assessment.name}` }}
        ></Typography>
      </div>
      {!assessment.is360 && (
        <Box>
          {completed && (
            <Button
              component={Link}
              to={`/profile/${assessment.slug}/${userId}`}
              className="assessmentCardButton"
              variant="contained"
              startIcon={<ArrowForwardIcon className="invertIcon" />}
            >
              View Results
            </Button>
          )}
          {!completed && (
            <>
              <Button
                className="assessmentCardButton borderButtonGreen"
                variant="contained"
                sx={{ marginRight: "30px", textWrap: "nowrap" }}
              >
                In process...
              </Button>
            </>
          )}
        </Box>
      )}
    </div>
  );
};

export default MyAssessmentCardProfile;
